import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import InputField from './InputField';
import CheckboxField from './CheckboxField';
import FormError from './FormError';
import { hasComma, isNotEmail } from '../helpers/validators';
import { formatSaveStatus } from '../helpers/formatters';
import { generateFakeEmail } from '../helpers/fake-email-generator';
import SelectField from './SelectField';

class NewUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAcl: null,
    };
    this.onSelectChange = this.onSelectChange.bind(this);
  }
  onSelectChange = ({ target: { value } }) => {
    this.setState({ selectedAcl: value });
  };
  componentDidUpdate(prevProps) {
    if (this.props.isEmail && this.props.isEmail !== prevProps.isEmail) {
      this.props.dispatch(change('newUser', 'email', generateFakeEmail()));
    }

    if (!this.props.isEmail && this.props.isEmail !== prevProps.isEmail) {
      this.props.dispatch(change('newUser', 'email', ''));
    }

    if (!this.props.isPhone && this.props.isPhone !== prevProps.isPhone) {
      this.props.dispatch(change('newUser', 'phone_number', ''));
    }
  }

  render() {
    const {
      submitSucceeded,
      userId,
      handleSubmit,
      saveStatus,
      error,
      isEmail,
      isPhone,
      isReseller,
      isAdmin,
      resellerUserTypes,
    } = this.props;

    if (submitSucceeded) {
      return <Redirect to={`/users/${userId}/new-address`} />;
    }

    return (
      <div>
        <h1>New User</h1>
        <form onSubmit={handleSubmit}>
          <div style={{ display: isEmail ? 'none' : 'block' }}>
            <Field component={InputField} name="email" label="Email*" />
          </div>
          <Field component={CheckboxField} name="no_email" type="checkbox" />
          <Field component={InputField} name="first_name" label="First Name*" />
          <Field component={InputField} name="last_name" label="Last Name*" />
          {(isAdmin || isReseller) && (
            <Field
              component={SelectField}
              name="acl_group_name"
              label="Acl Group Name*"
              empty="Select user group"
              options={resellerUserTypes}
              onChange={this.onSelectChange}
            />
          )}
          <div style={{ display: isPhone ? 'none' : 'block' }}>
            <Field
              component={InputField}
              name="phone_number"
              label="Phone Number"
            />
          </div>
          <Field component={CheckboxField} name="no_phone" type="checkbox" />

          {isAdmin && this.state.selectedAcl === 'RESELLER' && (
            <Field component={InputField} name="parent" label="Parent" />
          )}

          {error && <FormError error={error} />}
          <br />
          <button
            className="btn btn-default"
            disabled={saveStatus === 'PENDING'}
          >
            Create User
          </button>
          <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
        </form>
      </div>
    );
  }
}

const validate = (values, { isReseller }) => {
  let errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (isNotEmail(values.email)) {
    errors.email = 'Invalid email';
  }
  if (!values.first_name) {
    errors.first_name = 'Required';
  } else if (hasComma(values.first_name)) {
    errors.first_name = 'Comma sign is not allowed';
  }

  if (!values.last_name) {
    errors.last_name = 'Required';
  } else if (hasComma(values.last_name)) {
    errors.last_name = 'Comma sign is not allowed';
  }

  if (isReseller && !values.acl_group_name) {
    errors.acl_group_name = 'Required';
  }

  return errors;
};

NewUserForm = reduxForm({
  initialValues: {
    no_email: false,
    no_phone: false,
  },
  form: 'newUser',
  validate,
})(NewUserForm);

export default NewUserForm;
